import * as React from 'react';

class NoMatch extends React.Component<{
}, {}> {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    document.title = document.title + ": Not found";
  }

  public render() {
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md">
            <div className="boxed">
              <h1>Not found</h1>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default NoMatch;


// WEBPACK FOOTER //
// ./src/components/404/NoMatch.tsx